import React, { useState } from "react";
import { CardTitle, Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";

const tabContentSS = (formCapaianSS, triwulan, handleChangeForm, isInvalid) => {
  return (
    <TabPane tabId={triwulan}>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label for={`capaian_tw_${triwulan}`}>Capaian</Label>
            <Input
              id={`capaian_tw_${triwulan}`}
              name={`capaian_tw_${triwulan}`}
              type="number"
              min="0"
              max="999"
              value={formCapaianSS[`capaian_tw_${triwulan}`]}
              onChange={(e) => handleChangeForm(e)}
              invalid={isInvalid[`capaian_tw_${triwulan}`]}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label for={`capaian_normalisasi_tw_${triwulan}`}>Capaian Normalisasi</Label>
            <Input
              id={`capaian_normalisasi_tw_${triwulan}`}
              name={`capaian_normalisasi_tw_${triwulan}`}
              type="number"
              min="0"
              max="999"
              value={formCapaianSS[`capaian_normalisasi_tw_${triwulan}`]}
              onChange={(e) => handleChangeForm(e)}
              invalid={isInvalid[`capaian_normalisasi_tw_${triwulan}`]}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label for={`nilai_sasaran_strategis_tw_${triwulan}`}>Nilai SS</Label>
            <Input
              id={`nilai_sasaran_strategis_tw_${triwulan}`}
              name={`nilai_sasaran_strategis_tw_${triwulan}`}
              type="number"
              min="0"
              max="999"
              value={formCapaianSS[`nilai_sasaran_strategis_tw_${triwulan}`]}
              onChange={(e) => handleChangeForm(e)}
              invalid={isInvalid[`nilai_sasaran_strategis_tw_${triwulan}`]}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label for={`nilai_sasaran_strategis_normalisasi_tw_${triwulan}`}>Nilai SS Normalisasi</Label>
            <Input
              id={`nilai_sasaran_strategis_normalisasi_tw_${triwulan}`}
              name={`nilai_sasaran_strategis_normalisasi_tw_${triwulan}`}
              type="number"
              min="0"
              max="999"
              value={formCapaianSS[`nilai_sasaran_strategis_normalisasi_tw_${triwulan}`]}
              onChange={(e) => handleChangeForm(e)}
              invalid={isInvalid[`nilai_sasaran_strategis_normalisasi_tw_${triwulan}`]}
            />
          </FormGroup>
        </Col>
      </Row>
    </TabPane>
  );
}


const TabTriwulanCapaianSS = ({
  handleChangeForm,
  formCapaianSS,
  isInvalid,
  // statusCapaianList
}) => {

  const [activeTab, setActiveTab] = useState("1");

  const handleChangeTab = (tab) => {
    setActiveTab(tab)
  }

  return(
    <div>
      <Nav className="my-5" tabs justified>
        <NavItem>
          <NavLink
            className={activeTab === "1" ? "active" : ""}
            onClick={() => handleChangeTab("1")}
          >
            Triwulan 1
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "2" ? "active" : ""}
            onClick={() => handleChangeTab("2")}
          >
            Triwulan 2
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "3" ? "active" : ""}
            onClick={() => handleChangeTab("3")}
          >
            Triwulan 3
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "4" ? "active" : ""}
            onClick={() => handleChangeTab("4")}
          >
            Triwulan 4
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        {tabContentSS(formCapaianSS, "1", handleChangeForm, isInvalid)}
        {tabContentSS(formCapaianSS, "2", handleChangeForm, isInvalid)}
        {tabContentSS(formCapaianSS, "3", handleChangeForm, isInvalid)}
        {tabContentSS(formCapaianSS, "4", handleChangeForm, isInvalid)}
      </TabContent>
    </div>
  )
}

export default TabTriwulanCapaianSS;